import AboutPage from '../../components/pages/statics/AboutPage.vue'
export default {
  components: { AboutPage }
}
